var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "hotkey",
          rawName: "v-hotkey",
          value: _vm.keymap,
          expression: "keymap"
        }
      ],
      staticClass: "parent",
      staticStyle: { height: "calc(100vh - 50px)" }
    },
    [
      _c("dialogue", {
        attrs: {
          title: "Empty Box",
          paragraph: "Are you sure you want to empty box " + _vm.term + "?",
          button_names: ["Empty"],
          show: _vm.delete_dialogue
        },
        on: { dialogue: _vm.emptyBoxes, cancel: _vm.cancelDelete }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.scanText,
            expression: "scanText"
          }
        ],
        staticClass: "textfield",
        attrs: { id: "scanText", tabindex: "0" },
        domProps: { value: _vm.scanText },
        on: {
          change: _vm.scan,
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.scanText = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("layout-2", {
        key: _vm.updateKey,
        staticStyle: { width: "100%" },
        attrs: {
          id: _vm.pageid2,
          navbar: true,
          title: "Edit Inventory Item",
          use_radio: false,
          term: _vm.term,
          reroute: false
        },
        on: { save: _vm.checkItem }
      }),
      _vm._v(" "),
      _c("layout-1", {
        key: _vm.updateKey,
        staticStyle: { width: "100%", height: "calc(100vh - 350px)" },
        attrs: {
          table_name: "Items",
          filter_options: null,
          id: _vm.pageid1,
          searchbar: false,
          navbar: false,
          button_perm: "88",
          button_name: "Select",
          term: _vm.term,
          reroute: "/0322",
          select_reroute: true,
          usePages: false
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c(
          "div",
          _vm._l(_vm.nav_items, function(item, index) {
            return _vm.perms.includes(_vm.nav_item_perms[index])
              ? _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.button(item)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item))]
                )
              : _vm._e()
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f08dac6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f08dac6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/Edit_Inventory_Boxes.vue
// module id = 698
// module chunks = 0